module.exports = __webpack_public_path__ + "img/1483665943.36fcd261.jpg";